import { render, staticRenderFns } from "./HomepageLanguage.vue?vue&type=template&id=988bd118&"
import script from "./HomepageLanguage.vue?vue&type=script&lang=js&"
export * from "./HomepageLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports